export const GoalAndScopeKeys = {
  STUDY_NAME: 'studyName',
  PRODUCT_NAME: 'productName',
  STUDY_DESCRIPTION: 'studyDescription',
  PRODUCT_CODE: 'productCode',
  INDUSTRY_SECTOR: 'industrySector',
  HS_CODE: 'hsnCode',
  REPORTING_ORG: 'reportingOrg',
  STUDY_DATE: 'studyDate',
  REFERENCE_YEAR: 'referenceYear',
  INTENDED_APPLICATION: 'intendedApplication',
  PRODUCT_CN_CODE: 'productCNCode',
  PCF_STANDARD: 'pcfStandard',
  INTENDED_AUDIENCES: 'audienceSelection',
  STAGES: 'stages',
  STAGE_GATE: '_stageGate',
  AUDIENCE_OTHER: 'audienceOther',
  FU_QUANTITY: 'fuQuantity',
  FU_UNIT: 'fuUnit',
  FU_UNIT_OTHER: 'fuUnitOther',
  FU_DESCRIPTION: 'fuDescription',
  REFERENCE_FLOW: 'referenceFlow',
  BOUNDARY_SCOPE: 'boundaryScope',
  GEOGRAPHIC_SCOPE: 'geographicScope',
  LIFE_CYCLE_STAGES: 'lifeCycleStages',
  EXCLUSIONS: 'exclusions',
  ALLOCATION_METHOD: 'allocationMethod',
  EXPERT_MODE: 'expertMode'
};

export const GoalAndScopeLabels = {
  STUDY_NAME: 'Study Name',
  PRODUCT_NAME: 'Product / Material Name',
  STUDY_DESCRIPTION: 'Study Description',
  PRODUCT_CODE: 'Product Code / SKU',
  INDUSTRY_SECTOR: 'Industry Sector',
  HS_CODE: 'Relevant Product HSN code',
  REPORTING_ORG: 'Reporting Organization',
  STUDY_DATE: 'Study Date',
  REFERENCE_YEAR: 'Study Reference',
  INTENDED_APPLICATION: 'Intended Application of Study',
  PRODUCT_CN_CODE: 'Product CN Code',
  PCF_STANDARD: 'PCF Standard / Methodology',
  INTENDED_AUDIENCES: 'Intended Audience',
  AUDIENCE_OTHER: 'Others (Specify)',
  FU_QUANTITY: 'Quantity',
  FU_UNIT: 'Unit of Measurement',
  FU_UNIT_OTHER: 'Specify Unit',
  FU_DESCRIPTION: 'Description',
  REFERENCE_FLOW: 'Reference Flow',
  BOUNDARY_SCOPE: 'System Boundary Scope',
  GEOGRAPHIC_SCOPE: 'Geographic Scope',
  LIFE_CYCLE_STAGES: 'Life Cycle Stages Included',
  EXCLUSIONS: 'Exclusions & Cut-off Criteria',
  ALLOCATION_METHOD: 'Allocation Method',
  EXPERT_MODE: 'Expert Mode'
};

export const ProductionDataKeys = {
  MANUFACTURING_SETUP: 'setup',
  REFERENCE_PERIOD: 'period',
  REFERENCE_YEAR: 'year',
  TOTAL_UNITS_PRODUCED: 'units',
  SITES: 'sites',
  ALLOCATION_BASIS: 'allocationBasis',
  SITE_NAME: 'name',
  SITE_STATE: 'state',
  SITE_UNITS_PRODUCED: 'unitsProduced',
  SITE_PRODUCTION_TIME: 'productionTime',
  SITE_PRODUCTION_TIME_UNIT: 'productionTimeUnit',
  SITE_FLOOR_AREA: 'floorArea',
  SITE_FACILITY_THROUGHPUT: 'facilityThroughput'
};

export const ProductionDataLabels = {
  MANUFACTURING_SETUP: 'Manufacturing Setup',
  REFERENCE_PERIOD: 'Reference Period',
  REFERENCE_YEAR: 'Reference Year',
  TOTAL_UNITS_PRODUCED: 'Total Units Produced (Entire Period)',
  SITES: 'Manufacturing Sites',
  ALLOCATION_BASIS: 'Allocation Basis for Shared Facilities',
  SITE_NAME: 'Site Name / Label',
  SITE_STATE: 'Site Location (State)',
  SITE_UNITS_PRODUCED: 'Units Produced at This Site',
  SITE_PRODUCTION_TIME: 'Production Time for This Product',
  SITE_PRODUCTION_TIME_UNIT: 'Production Time Unit',
  SITE_FLOOR_AREA: 'Floor Area of Production Line (m²)',
  SITE_FACILITY_THROUGHPUT: 'Total Facility Throughput (All Products)'
};

export const A1MaterialsKeys = {
  MATERIALS: 'materials',
  MATERIAL_NAME: 'name',
  QUANTITY_PER_UNIT: 'qty',
  UNIT: 'unit',
  MATERIAL_SOURCING: 'sourcing',
  SUPPLIER_EMISSION_FACTOR: 'supplierEF',
  SUPPLIER_EF_VALUE: 'supplierEfValue',
  SUPPLIER_EF_SOURCE: 'supplierEfSource',
  EMISSION_FACTOR: 'emissionFactor',
  CONFIDENCE: 'confidence',
  PACKAGING_CHECKLIST: 'packaging'
};

export const A1MaterialsLabels = {
  MATERIAL_NAME: 'Material Name',
  QUANTITY_PER_UNIT: 'Quantity per unit',
  UNIT: 'Unit',
  MATERIAL_SOURCING: 'Material Sourcing',
  SUPPLIER_EMISSION_FACTOR: 'Supplier Emission Factor?',
  SUPPLIER_EF_VALUE: 'Supplier EF Value (kg CO₂e per unit)',
  SUPPLIER_EF_SOURCE: 'Source / Citation',
  EMISSION_FACTOR: 'Emission Factor (kg CO₂e per unit)',
  CONFIDENCE: 'Confidence',
  PACKAGING_CHECKLIST: 'Packaging & Ancillary Checklist'
};

export const LogisticsKeys = {
  ITEMS: 'items',
  SHIP_TO: 'shipTo',
  MATERIAL: 'material',
  SUPPLIER_CITY: 'supplierCity',
  DESTINATION_CITY: 'destinationCity',
  MODE: 'mode',
  DISTANCE: 'distance',
  ANNUAL_QUANTITY: 'annualQuantity',
  LOAD_FACTOR: 'loadFactor',
  LTL_LOAD_PERCENT: 'ltlLoadPercent',
  MIXED_MODE_SPLIT: 'mixedModeSplit',
  EF: 'ef',
  RETURN_JOURNEY: 'returnJourney'
};

export const LogisticsLabels = {
  SHIP_TO: 'Who do you ship finished products to?',
  MATERIAL: 'Material / Input Being Transported',
  SUPPLIER_CITY: 'Supplier City / Origin',
  DESTINATION_CITY: 'Destination (City / Region)',
  MODE: 'Transport Mode',
  DISTANCE: 'Distance (km)',
  ANNUAL_QUANTITY: 'Annual Quantity (Reference Period)',
  LOAD_FACTOR: 'Truck Load Factor',
  LTL_LOAD_PERCENT: 'Typical Load Share (%)',
  MIXED_MODE_SPLIT: 'Mixed Mode Split (%)',
  EF: 'Emission Factor (kg CO2e per tonne-km)',
  RETURN_JOURNEY: 'Return Journey?'
};

export const A3ManufacturingKeys = {
  FACILITIES: 'facilities',
  ENERGY: 'energy',
  PROCESS: 'process',
  WATER: 'water',
  WASTE: 'waste',
  ALLOCATION_BASIS: 'allocationBasis',
  FACILITY_THROUGHPUT: 'facilityThroughput',
  CONFIGURED: 'configured',
  HAS_PROCESS_EMISSIONS: 'hasProcessEmissions',
  PROCESS_ALLOCATION_SCOPE: 'processAllocationScope',
  WASTE_TYPES_SELECTED: 'wasteTypesSelected',
  NO_WASTE_JUSTIFICATION: 'noWasteJustification',
  ENERGY_TYPE: 'type',
  TOTAL_QUANTITY: 'quantity',
  ENERGY_UNIT: 'unit',
  GRID_ZONE: 'zone',
  ENERGY_EMISSION_FACTOR: 'ef',
  REC_ENABLED: 'rec',
  REC_QUANTITY: 'recQty',
  PROCESS_EMISSION_TYPE: 'type',
  PROCESS_EMISSION_QUANTITY: 'qty',
  GWP100_FACTOR: 'gwp',
  WATER_CONSUMPTION: 'consumption',
  WATER_STRESS_REGION: 'region',
  WASTE_TYPE: 'type',
  WASTE_QUANTITY: 'qty',
  WASTE_TREATMENT: 'treatment',
  WASTE_SCOPE: 'wasteScope',
  WASTE_TREATMENT_EMISSION_FACTOR: 'ef'
};

export const A3ManufacturingLabels = {
  ALLOCATION_BASIS: 'Allocation Basis',
  FACILITY_THROUGHPUT: 'Total Facility Throughput (All Products)',
  HAS_PROCESS_EMISSIONS:
    'Does your process release greenhouse gases directly (not from fuel)?',
  PROCESS_ALLOCATION_SCOPE: 'Emission Scope',
  WASTE_TYPES_SELECTED: 'Manufacturing Waste Types',
  NO_WASTE_JUSTIFICATION: 'Justification for No Significant Waste',
  ENERGY_TYPE: 'Energy Type',
  TOTAL_QUANTITY: 'Total Quantity Consumed at Facility',
  ENERGY_UNIT: 'Energy Unit',
  GRID_ZONE: 'Grid Zone',
  ENERGY_EMISSION_FACTOR: 'Emission Factor (kg CO2e per unit)',
  REC_ENABLED: 'Renewable Energy Certificate (REC)?',
  REC_QUANTITY: 'Annual REC / PPA quantity covered (kWh)',
  PROCESS_EMISSION_TYPE: 'Process Emission Type',
  PROCESS_EMISSION_QUANTITY: 'Total Amount Released (Reference Period)',
  GWP100_FACTOR: 'GWP100 Factor',
  WATER_CONSUMPTION: 'Water Consumption (m3 per FU)',
  WATER_STRESS_REGION: 'Water Stress Region',
  WASTE_TYPE: 'Waste Type',
  WASTE_QUANTITY: 'Total Waste Generated (Reference Period)',
  WASTE_TREATMENT: 'Waste Treatment / Destination',
  WASTE_SCOPE: 'Waste Scope',
  WASTE_TREATMENT_EMISSION_FACTOR: 'Waste Treatment Emission Factor'
};

export const BUseKeys = {
  USES_ENERGY_IN_USE: 'usesEnergyInUse',
  ENERGY_TYPE: 'energyType',
  ANNUAL_ENERGY_PER_UNIT: 'annualEnergyPerUnit',
  ENERGY_UNIT: 'energyUnit',
  SERVICE_LIFE: 'serviceLife',
  SERVICE_LIFE_UNIT: 'serviceLifeUnit',
  HAS_CONSUMABLES: 'hasConsumables',
  CONSUMABLES: 'consumables',
  CONSUMABLE_TYPE: 'type',
  CONSUMABLE_QUANTITY: 'quantity',
  CONSUMABLE_FREQUENCY: 'frequency',
  ITEMS: 'items',
  SUB_STAGE: 'subStage',
  DESCRIPTION: 'description',
  QTY: 'qty',
  UNIT: 'unit'
};

export const BUseLabels = {
  USES_ENERGY_IN_USE: 'Does your product consume energy during use?',
  ENERGY_TYPE: 'Energy Type During Use',
  ANNUAL_ENERGY_PER_UNIT: 'Energy Consumed per Year (per Unit)',
  ENERGY_UNIT: 'Energy Unit',
  SERVICE_LIFE: 'Expected Service Life',
  SERVICE_LIFE_UNIT: 'Service Life Unit',
  HAS_CONSUMABLES: 'Requires periodic replacement of parts or consumables?',
  CONSUMABLE_TYPE: 'Consumable Type',
  CONSUMABLE_QUANTITY: 'Quantity per Replacement',
  CONSUMABLE_FREQUENCY: 'Replacements per Year',
  SUB_STAGE: 'Sub-Stage',
  DESCRIPTION: 'Activity Description',
  QTY: 'Qty / Year',
  UNIT: 'Unit'
};

export const CEndOfLifeKeys = {
  DISPOSAL_ROUTES: 'disposalRoutes',
  DISPOSAL_ROUTE: 'route',
  DISPOSAL_PERCENT: 'percent',
  DISPOSAL_TRANSPORT: 'disposalTransport',
  HAS_RECOVERABLE_VALUE: 'hasRecoverableValue',
  RECOVERABLE_TYPE: 'recoverableType',
  RECOVERABLE_FRACTION: 'recoverableFraction',
  ITEMS: 'items',
  SUB_STAGE: 'subStage',
  ACTIVITY: 'activity',
  QTY: 'qty',
  UNIT: 'unit'
};

export const CEndOfLifeLabels = {
  DISPOSAL_ROUTES: 'End-of-Life Routes',
  DISPOSAL_ROUTE: 'Route',
  DISPOSAL_PERCENT: 'Share (%)',
  DISPOSAL_TRANSPORT: 'End-of-Life Transport',
  HAS_RECOVERABLE_VALUE: 'Recoverable Value at End of Life (Module D)?',
  RECOVERABLE_TYPE: 'Recoverable Material / Value Type',
  RECOVERABLE_FRACTION: 'Recoverable Fraction',
  SUB_STAGE: 'Sub-Stage',
  ACTIVITY: 'Activity / Treatment Type',
  QTY: 'Qty / Year',
  UNIT: 'Unit'
};

export const ImpactConfigurationKeys = {
  LCIA_METHOD: 'lciaMethod',
  GWP_TIME_HORIZON: 'gwpHorizon',
  BIOGENIC_CARBON_HANDLING: 'biogenicHandling',
  LUC_EMISSIONS: 'luc',
  CARBON_SEQUESTRATION: 'sequestration',
  EF_DATABASE_VERSION: 'efDatabaseVersion',
  UNCERTAINTY_ANALYSIS: 'uncertainty',
  UNCERTAINTY_ITERATIONS: 'uncertaintyIterations'
};

export const ImpactConfigurationLabels = {
  LCIA_METHOD: 'LCIA Method',
  GWP_TIME_HORIZON: 'GWP Time Horizon',
  BIOGENIC_CARBON_HANDLING: 'Biogenic Carbon Handling',
  LUC_EMISSIONS: 'Land Use Change (LUC) Emissions',
  CARBON_SEQUESTRATION: 'Carbon Sequestration / Temporary Storage',
  EF_DATABASE_VERSION: 'Emission Factor Database Version',
  UNCERTAINTY_ANALYSIS: 'Uncertainty Analysis',
  UNCERTAINTY_ITERATIONS: 'Number of iterations'
};

export const ReportExportKeys = {
  REPORT_TYPE: 'reportType',
  REPORT_LANGUAGE: 'reportLanguage',
  COMPANY_LOGO: 'companyLogo',
  VERIFICATION_STATUS: 'verificationStatus',
  SIGNATORY_NAME: 'signatoryName',
  SIGNATORY_DESIGNATION: 'signatoryDesignation',
  THIRD_PARTY_VERIFICATION: 'thirdPartyVerification',
  EXPORT_FORMAT: 'formats',
  SHARE_PUBLISH: 'shareStudy'
};

export const ReportExportLabels = {
  REPORT_TYPE: 'Report Type',
  REPORT_LANGUAGE: 'Report Language',
  COMPANY_LOGO: 'Company Logo Upload',
  VERIFICATION_STATUS: 'Verification Status',
  SIGNATORY_NAME: 'Signatory Name',
  SIGNATORY_DESIGNATION: 'Signatory Designation',
  THIRD_PARTY_VERIFICATION: 'Third-Party Verification Status',
  EXPORT_FORMAT: 'Export Format',
  SHARE_PUBLISH: 'Share / Publish Study'
};

export const ResultsInterpretationKeys = {
  KEY_FINDINGS: 'keyFindings',
  LIMITATIONS: 'limitations',
  BENCHMARK_VALUE: 'benchmarkValue',
  BENCHMARK_LABEL: 'benchmarkLabel'
};

export const ResultsInterpretationLabels = {
  KEY_FINDINGS: 'Interpretation - Key Findings',
  LIMITATIONS: 'Interpretation - Limitations',
  BENCHMARK_VALUE: 'Benchmark Value (kg CO₂e per FU)',
  BENCHMARK_LABEL: 'Benchmark label'
};
